<template>
	<div class="role">
		<div class="left-menus">
			<div class="add-action" @click="showDialog('add')">
				<div class="add-action-img"></div>
				<div class="add-action-text">添加企业</div>
			</div>
			<div class="left-list">
				<div :class="enpId == item.id ? 'left-enp-item-active' : 'left-enp-item'" v-for="item in companyList"
					:key="item.id" @click="handleEnp(item.id)">
					<div class="enp-item-name" :title="item.name">{{item.id}}·{{item.name}}</div>
				</div>
			</div>
		</div>

		<div class="right-list">

			<div class="right-query">
				<h3 class="qjc-fts-20 qjc-c-dark qjc-ftw-500 corp_name">{{corpId}}·{{corpName}} </h3>
				<el-button class="right-btn-active" @click="showDialog('editCompany')">编辑</el-button>
				<el-button class="right-btn-active" v-if="isAPI" @click="handleIsApiEdit">新增套餐</el-button>

			</div>
			<el-table :data="userPackage" :fit="true" v-if="!isAPI" row-key="name" default-expand-all
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column label="编号" prop="goods_id" width="60"></el-table-column>
				<el-table-column label="套餐内容" prop="name" min-width="160"
				class="table-text">
					<template slot-scope="scope">
						<div class="" v-if="scope.row.goods_id == '2'">{{scope.row.name}}</div>
						<div class="" v-if="scope.row.goods_id != '2'">
							<el-collapse v-if="(scope.row.corpList && scope.row.corpList.length > 0)">
								<el-collapse-item name="1">
									<template class="" slot="title">
										<div class="tips-name">{{scope.row.name}}</div>
									</template>
									<div class="tips-text" v-if="(scope.row.corpList && scope.row.corpList.length > 0)"
										v-for="item in scope.row.corpList">
										{{item.created_at}} 添加次数{{item.num}}次
									</div>
								</el-collapse-item>
							</el-collapse>
							<div class="" v-else>{{scope.row.name}}</div>

						</div>
					</template>
				</el-table-column>



				<el-table-column label="付费方式" prop="name" min-width="100"
				class="table-text">
					<template slot-scope="scope">
						{{userData.pay_mode == '1' ? '预付费' : '后付费'}}
					</template>
				</el-table-column>
				<el-table-column label="总量" prop="times" min-width="120"
				class="table-text">
					<template slot-scope="scope">
						<div class="used_cell">
							<div v-if="userData.pay_mode == '2'">-</div>
							<div v-else>{{scope.row.times ?  scope.row.times : 0 }}</div>
							<div class="used_cell_btn" v-if="userData.pay_mode == '1' && scope.row.status == '1'"
								@click="handleSelectItem(scope.row)">增加用量</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="累计使用" prop="used" min-width="100"
				class="table-text">
					<template slot-scope="scope">
						<div class="used_cell">
							<div class="">{{scope.row.used ? scope.row.used : '0'}}</div>
							<div class="used_cell_btn"
								v-if="scope.row.goods_id && scope.row.goods_id != 2 && scope.row.used > 0"
								@click="handleUsedHistory(scope.row)">查看</div>
							<div class="used_cell_btn" v-if="scope.row.goods_id && scope.row.goods_id == 2 && hasUsed"
								@click="handleUsedHistory(scope.row)">查看</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="状态" prop="status" min-width="80">
					<template slot-scope="scope">
						<div v-if="scope.row.status == '1'" class="order_status_80">正常</div>
						<div class="pay_status_1" v-else>已停用</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="120px" >
					<template slot-scope="scope">
						<div class="qjc-flex">
							<div class="edit-action">


								<span class="edit-text" v-if="userData.pay_mode == '1' && scope.row.times"
									@click="handleAddHistory(scope.row)">用量记录</span>
							</div>
						</div>
					</template>
				</el-table-column>

			</el-table>

			<el-table :data="userApi" :fit="true" v-if="isAPI" row-key="name" :height="mainHeight -110 + 'px'"
				default-expand-all :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<el-table-column label="套餐内容" prop="name" width="300px">
				</el-table-column>
				<!-- <el-table-column
					label="展示形式"
					prop="name"
				>
					<template slot-scope="scope">
						{{userData.package_opt == '0' ? '固定' : '不固定'}}
					</template>
				</el-table-column> -->

				<el-table-column label="付费方式" prop="name">
					<template slot-scope="scope">
						{{userData.pay_mode == '1' ? '预付费' : '后付费'}}
					</template>
				</el-table-column>
				<el-table-column label="总量" prop="times">
					<template slot-scope="scope">
						<div class="">{{userData.pay_mode == '1' ? (scope.row.times ? scope.row.times : '0') : '--'}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="累计使用" prop="used">
					<template slot-scope="scope">
						<div class="">{{scope.row.used ? scope.row.used : '0'}}</div>
					</template>
				</el-table-column>

			</el-table>
		</div>

		<!-- 新增、修改弹窗 -->
		<el-dialog 		  :close-on-click-modal="false" :title="(oper == 'add'?'新增企业':(oper == 'edit'?'修改套餐信息':'修改企业信息'))" :visible.sync="isAlert"
			width="900px" :show-close="true" @close="formCancel">
			<div class="popup-wrap">
				<div class="right-temp" v-if="oper == 'add'">
					<div class="api-cell">
						<div class="api-cell-title">付费方式</div>
						<el-radio-group :disabled="oper == 'edit' || oper == 'editCompany'" v-model="pay_mode"
							active-color="#6681FA">
							<el-radio label="1">预付费</el-radio>
							<el-radio label="2">后付费</el-radio>
						</el-radio-group>
					</div>
				
				</div>
				<div class="right-temp" v-if="oper == 'add' || oper == 'editCompany'">
					<div class="api-cell">
						<div class="api-cell-title">企业名称</div>
						<el-input type="text" placeholder="请输入企业名称" class="item-input"
							v-model.trim="userName"></el-input>
					</div>

				</div>
				<div class="right-temp" v-if="oper == 'add'">
					<div class="api-cell">
						<div class="api-cell-title">开通企业后台</div>
						<el-radio-group v-model="hasBackPackage" active-color="#6681FA">
							<el-radio label="1">是</el-radio>
							<el-radio label="0">否</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="right-temp" v-if="hasBackPackage == '1'">
					<div class="api-cell">
						<div class="api-cell-title">商品</div>
						<div class="checkbox-group-box" >
							<div class="temp-info" v-for="(goods, goodsIndex) in goodsList">
								<el-checkbox-group class="custom-group" v-model="goodsCheckList">
									<div class="info-cell" v-if="goods.id != '2'">
										<el-checkbox :label="goods.id">{{goods.name}}</el-checkbox>
									</div>
								</el-checkbox-group>
							</div>
						</div>
					</div>
				</div>
				
				<div class="right-temp" >
					
					


					<div class="temp-info" v-if="oper == 'add'|| oper == 'editCompany'">
						<div class="api-cell">
							<div class="api-cell-title">appid</div>
							<el-input class="api-cell-input" v-model.trim="appid"></el-input>
						</div>
						<div class="api-cell">
							<div class="api-cell-title">appsecret</div>
							<el-input class="api-cell-input" v-model.trim="appsecret"></el-input>
						</div>
						<div class="api-cell">
							<div class="api-cell-title">IP</div>
							<el-input class="api-cell-input" v-model.trim="ip"></el-input>
						</div>
						<div class="api-cell">
							<div class="api-cell-title"></div>
							<div style="color: #999;">多个IP以逗号隔开</div>
						</div>
						<div class="api-cell">
							<div class="api-cell-title">是否启用</div>
							<el-switch v-model="corp_status" active-value="1" inactive-value="0" active-color="#38E019"
								inactive-color="#FF5219">
							</el-switch>
						</div>

					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit">提交</el-button>
			</span>
		</el-dialog>
		<el-dialog 		  :close-on-click-modal="false" title="修改企业" :visible.sync="isAlert2" width="1000px" :show-close="true" @close="formCancel">
			<div class="popup-wrap">
				<div class="right-temp">
					<div class="api-cell">
						<div class="api-cell-title">企业名称</div>
						<el-input type="text" placeholder="请输入企业名称" class="item-input"
							v-model.trim="userName"></el-input>
					</div>

				</div>

				<div class="temp-info">
					<div class="api-cell">
						<div class="api-cell-title">appid</div>
						<el-input class="api-cell-input" v-model.trim="appid"></el-input>
					</div>
					<div class="api-cell">
						<div class="api-cell-title">appsecret</div>
						<el-input class="api-cell-input" v-model.trim="appsecret"></el-input>
					</div>
					<div class="api-cell">
						<div class="api-cell-title">IP</div>
						<el-input class="api-cell-input" v-model.trim="ip"></el-input>
					</div>
					<div class="api-cell">
						<div class="api-cell-title"></div>
						<div style="color: #999;">多个IP以逗号隔开</div>
					</div>
					<div class="api-cell">
						<div class="api-cell-title">是否启用</div>
						<el-switch v-model="corp_status" active-value="1" inactive-value="0" active-color="#38E019"
							inactive-color="#FF5219">
						</el-switch>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit2">提交</el-button>
			</span>
		</el-dialog>
		<!-- 新增、修改弹窗 -->
		<el-dialog		  :close-on-click-modal="false" title="新增套餐" :visible.sync="isAlert3" width="1000px" :show-close="true" @close="formCancel">
			<div class="popup-wrap">
				<div class="right-temp">
					<div class="api-cell">
						<div class="api-cell-title">付费方式</div>
						<el-radio-group :disabled="oper == 'edit'" v-model="pay_mode" active-color="#6681FA">
							<el-radio label="1">预付费</el-radio>
							<el-radio label="2">后付费</el-radio>
						</el-radio-group>
					</div>
				</div>
				<div class="right-temp">
					<div class="temp-title-cell">
						<div class="temp-title">套餐开通</div>
					</div>
					<div class="temp-info padding_left_20" v-for="(goods, goodsIndex) in goodsList">
						<el-checkbox-group class="custom-group" v-model="goodsCheckList">
							<div class="info-cell" v-if="goods.id != '2'">
								<el-checkbox :label="goods.id"
									:disabled="pay_mode == '1' || !hasPackage">{{goods.name}}</el-checkbox>
							</div>
						</el-checkbox-group>
						<div class="info-cell" v-if="goods.id == '2'">
							<el-checkbox v-model="isCustom"
								:disabled="pay_mode == '1' || !hasPackage">{{goods.name}}</el-checkbox>
							<div class="custom-info" v-show="isCustom">

								<div class="custom-item">
									<el-checkbox label="base"
										:disabled="isCustom">{{goods.custom && goods.custom.base.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="mlev"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.mlev.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="packageA"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.packageA.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="packageB"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.packageB.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="packageC"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.packageC.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="packageD"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.packageD.name}}</el-checkbox>
								</div>
								<div class="custom-item">
									<el-checkbox label="packageFB"
										:disabled="(isCustom && pay_mode == '1') || !hasPackage">{{goods.custom && goods.custom.packageFB.name}}</el-checkbox>
								</div>
								</el-checkbox-group>
							</div>
						</div>
					</div>
					<div class="right-temp" v-show="isCustom">
						<div class="api-cell">
							<div class="api-cell-title">套餐展示形式</div>
							<el-radio-group v-model="package_opt">
								<el-radio :disabled="!hasPackage" label="0">固定</el-radio>
								<el-radio :disabled="!hasPackage" label="1">不固定</el-radio>
							</el-radio-group>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="formCancel">取消</el-button>
				<el-button class="submit-btn" @click="formSubmit3">提交</el-button>
			</span>
		</el-dialog>


		<el-dialog 		  :close-on-click-modal="false" title="添加次数" :visible.sync="isAddTimes" width="700px" :show-close="true" @close="formCancelTimes">
			<div class="add-times">
				<div class="qjc-flex qjc-al-c">
					<div class="add-times-label">添加次数</div>
					<el-input-number class="" 
						v-model.trim="addTimes" 
						:min="1" 
						:max="10000" 
						placeholder="请输入添加的次数"  
						:precision="0"
						@change="changeAddTimes"></el-input-number>
				</div>
				<div class="foot-btn">
					<el-button class="cancel-btn" @click="formCancelTimes">取消</el-button>
					<el-button class="submit-btn" @click="handleAddTimes">提交</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog 	  :close-on-click-modal="false" title="企业用量操作记录" :visible.sync="isAddShow" width="60%" class="used_dialog">
			<el-table :data="addHistoryList" style="width: 100%">
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<el-table-column label="编号" prop="id"></el-table-column>
				<el-table-column label="企业名称" prop="corp_name"></el-table-column>
				<el-table-column label="操作状态" prop="type">
					<template slot-scope="scope">
						<div v-if="scope.row.type == 1" >增加</div>
						<div v-else-if="scope.row.type == 2">减少</div>
					</template>
				</el-table-column>
				<el-table-column label="操作前" prop="before"></el-table-column>
				<el-table-column label="次数" prop="num"></el-table-column>
				<el-table-column label="操作后" prop="after"></el-table-column>
				<el-table-column label="操作人" prop="operator" width="160"></el-table-column>
				<el-table-column label="操作时间" prop="created_at" width="200"></el-table-column>
			</el-table>

			<!-- 分页 -->
			<el-pagination @current-change="pageChange2" :current-page.sync="pager2.page" hide-on-single-page
				:page-size="pager2.pagesize" 
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper" :total="pager2.count">
			</el-pagination>
		</el-dialog>

		<el-dialog 		  :close-on-click-modal="false" 	 title="企业套餐使用记录" :visible.sync="isUsedShow" width="60%" class="used_dialog">
			<el-table :data="usedHistoryList" style="width: 100%">
				<template slot="empty">
					<div class="empty-wrap">
						<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
						<div class="empty-text">暂无数据</div>
					</div>
				</template>
				<el-table-column label="编号" prop="id" width="60"></el-table-column>
				<el-table-column label="企业名称" prop="corp_name"></el-table-column>
				<el-table-column label="手机号/企业用户ID" prop="mobile" min-width="160px"></el-table-column>
				<el-table-column label="套餐名称" prop="goods_name" min-width="160px">
					<template slot-scope="scope">
						<span>{{ scope.row.goods_name }}</span>
						<span class="custom_info" v-if="scope.row.custom">
							<el-tooltip :content="scope.row.custom" placement="bottom">
								<i class="el-icon-info"></i>
							</el-tooltip>
						</span>

					</template>
				</el-table-column>
				<el-table-column label="操作时间" prop="created_at" min-width="200"></el-table-column>
				<el-table-column label="操作" min-width="120px" fixed="right">
					<template slot-scope="scope">
						<div class="qjc-flex">
							<div class="edit-action">
								<span class="edit-text"
									@click="handleReport(scope.row.id, scope.row.goods_id,scope.row.type)">查看报告</span>
							</div>
						</div>

					</template>
				</el-table-column>
			</el-table>

			<!-- 分页 -->
			<el-pagination @current-change="pageChange3" :current-page.sync="pager3.page" hide-on-single-page
				:page-size="pager3.pagesize" 
				prev-text="上一页"
				next-text="下一页"
				layout="total, prev, pager, next,jumper" :total="pager3.count">
			</el-pagination>
		</el-dialog>

	</div>
</template>

<script>
	import {
		enterpriseList,
		adminRole,
		getGoodsList
	} from "@/utils/axios"
	
	import {Base64} from 'js-base64'

	export default {
		name: 'adminEnterprise',
		data() {
			return {
				isAlert: false,
				isAlert2: false,
				isAlert3: false,
				isAddTimes: false,
				hasPackage: false,
				hasBackPackage: '1',
				mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) -
					60,
				hasApi: false,
				isAddShow: false,
				isUsedShow: false,
				hasUsed: false,
				addTimes: '',
				oper: '',
				id: '',
				apiUserName: '',
				appid: '',
				appsecret: '',
				ip: '',
				apiTimes: '',
				apiData: [],
				list: [],
				userName: '', //公司名称
				packageCheackList: ['base', 'mlev'], //选中套餐
				package_opt: '0', //是否可勾选 0 不可勾选   1 可勾选
				pay_mode: '1', //付费模式 1 预付费  2 后付费
				pager: {
					page: 1,
					pagesize: 12,
					count: 0
				},
				pager2: {
					page: 1,
					pagesize: 12,
					count: 0
				},
				pager3: {
					page: 1,
					pagesize: 10,
					count: 0
				},
				roles: [], // 角色列表

				enpId: 0,
				companyList: [],

				isCustom: true,


				healthTimes: '',
				myTimes: '',

				isFreq: false, // 增加次数

				userData: {}, //企业信息
				userPackage: [],
				userApi: [],


				goodsCheckList: [],


				timesPackage: '',
				timesCustom: '',
				adminId: '',
				isAPI: false,
				goodsList: [],
				formList: [],
				addHistoryList: [],
				corp_status: '0',
				corpId: '',
				corpName: '',
				usedHistoryList: [],
			}
		},
		mounted() {
			this.$nextTick(() => {
				this.handleLoadCom()
				// this.handleGoodsList()
			})
		},
		watch: {
			// 监听选中套餐列表  基础项是否选中
			packageCheackList(newVal, oldVal) {
				if (newVal.indexOf('base') == -1) {
					this.packageCheackList.unshift('base')
				}

			},
			isCustom(newVal) {
				if (newVal) {

					if (this.goodsCheckList.indexOf('2') <= -1) {
						this.goodsCheckList.push('2')
					}
				} else {
					this.goodsCheckList.splice(this.goodsCheckList.indexOf('2'), 1)
				}
			},
			pay_mode(newVal) {
				if (newVal == '1') {
					this.isCustom = true

					this.handleGoodsList()

				}
			},
			goodsCheckList(newVal) {
				if (newVal.length > 0) {
					let list = []
					newVal.map((item, index) => {
						list[index] = {
							goods_id: item,
							status: '1'
						}
					})
					this.formList = list
				} else {
					this.formList = []
				}
			},
			addTimes(newVal) {
				/* if (newVal && typeof newVal == 'string') {
					this.addTimes = newVal.replace(/[^\d]/g, "")
				} else {
					this.addTimes = ''
				} */
			},
			userName(val){
				if (val) {
					this.userName = val.replace(/\s+/g,"")
				}
			},
			appid(val){
				if (val) {
					this.appid = val.replace(/\s+/g,"")
				}
			},
			appsecret(val){
				if (val) {
					this.appsecret = val.replace(/\s+/g,"")
				}
			},
			ip(val){
				if (val) {
					this.ip = val.replace(/\s+/g,"")
				}
			},
		},
		methods: {
			handleGoodsList() {
				getGoodsList().then((res) => {
					if (res.code == 200) {
						let goodsList = JSON.parse(window.atob(res.data))
						this.goodsList = goodsList;
						let list = []
						goodsList.map((goods) => {
							list.push(goods.id)
						})
						if (this.oper == 'add') {
							this.goodsCheckList = list
						}
					}
				})
			},
			handleLoadCom() {
				enterpriseList({
					act: ''
				}).then((res) => {
					if (res.code == 200) {
						let companyList = JSON.parse(window.atob(res.data))
						this.companyList = companyList;
						if (!this.enpId) {
							this.enpId = companyList[0].id
						}

						this.handleEnp(this.enpId)
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleApiTimes(val) {
				let patten = /^[1-9][0-9]*$/
				if (!patten.test(val)) {
					this.apiTimes = ''
				}
			},
			handleIsAPI(isAPI) {
				this.isAPI = isAPI
				if (isAPI) {
					let obj = {
						appid: this.userData.appid,
						appsecret: this.userData.appsecret,
						ip: this.userData.ip
					}
					this.apiData.push(obj)
				} else {
					this.apiData = [];
					this.handleEnp(this.enpId)
				}
			},
			// 获取选中套餐信息
			handleSelectItem(row) {
				if (!this.isAPI) {
					if (row.goods_id) {
						this.timesPackage = row.goods_id
					} else {
						this.timesPackage = '2'
						this.timesCustom = row.key
					}
					this.isAddTimes = true;
				} else {
					this.isAddTimes = true;
				}

			},
			handleAddHistory(row) {
				if (!this.isAPI) {
					if (row.goods_id) {
						this.timesPackage = row.goods_id
						this.timesCustom = ''
						let data = {
							page: this.pager2.page,
							pagesize: this.pager2.pagesize
						};
						data.corp_id = this.id;
						data.goods_id = row.goods_id;
						data.act = "addTimesRecord";
						this.handleAddHistoryList(data)
					} else {
						this.timesPackage = '2'
						this.timesCustom = row.key
						let data = {
							page: this.pager2.page,
							pagesize: this.pager2.pagesize
						};
						data.corp_id = this.id;
						data.goods_id = 2;
						data.act = "addTimesRecord";
						this.handleAddHistoryList(data)
					}
					this.isAddShow = true
				}
			},
			handleAddHistoryList(data) {
				enterpriseList(data).then((res) => {
					if (res.code == 200) {
						const data = JSON.parse(window.atob(res.data))
						this.addHistoryList = data.data;
						this.pager2 = data.pager;

						// 数值可能为字符串，需转换为number
						for (var key in this.pager2) {
							this.pager2[key] = parseInt(this.pager2[key]);
						}

					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleUsedHistory(row) {
				if (!this.isAPI) {
					if (row.goods_id) {
						this.timesPackage = row.goods_id
						this.timesCustom = ''
						let data = {
							page: this.pager3.page,
							pagesize: this.pager3.pagesize
						};
						data.corp_id = this.id;
						data.goods_id = row.goods_id;
						data.act = "usedRecord";
						this.handleUsedHistoryList(data)
					}
					this.isUsedShow = true
				}
			},
			handleUsedHistoryList(data) {
				enterpriseList(data).then((res) => {
					if (res.code == 200) {
						const result = JSON.parse(window.atob(res.data))
						this.usedHistoryList = result.data;
						this.pager3 = result.pager;
						// 数值可能为字符串，需转换为number
						for (var key in this.pager2) {
							this.pager3[key] = parseInt(this.pager3[key]);
						}

					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			pageChange2(page) {
				this.pager2.page = page;
				let data = {
					...this.pager2
				};
				data.corp_id = this.id;
				data.goods_id = this.timesPackage;
				data.act = "addTimesRecord";
				this.handleAddHistoryList(data);
			},
			pageChange3(page) {
				this.pager3.page = page;
				let data = {
					...this.pager3
				};
				data.corp_id = this.id;
				data.goods_id = this.timesPackage;
				data.act = "usedRecord";
				this.handleUsedHistoryList(data);
			},
			// 增添次数失去焦点
			handleAddTimesBlur(e) {
				return 
				if (this.addTimes <= 0) {
					this.$myAlert({
						type: 'fail',
						title: '增添次数最小为1'
					});
				}
			},
			//关闭增添次数弹窗
			formCancelTimes() {
				this.addTimes = 1
				this.isAddTimes = false;
			},
			// 提交增添次数
			handleAddTimes() {
				if (this.addTimes <= 0) {
					this.$myAlert({
						type: 'fail',
						title: '增添次数最小为1'
					});

					return
				}
				if (!this.isAPI) {
					let mobile = localStorage.getItem('mobile');
					enterpriseList({
						act: 'addTimes',
						corp_id: this.id,
						goods_id: this.timesPackage,
						num: this.addTimes,
						operator: mobile,
					}).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleEnp(this.enpId);
							this.isAddTimes = false;
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.isAddTimes = false;
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				} else {
					let mobile = localStorage.getItem('mobile');
					enterpriseList({
						act: 'addApiTimes',
						corp_id: this.id,
						num: this.addTimes,
						operator: mobile,
					}).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleEnp(this.enpId);
							this.isAddTimes = false;
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.isAddTimes = false;
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				}
			},

			// 参数：修改(edit)或添加(add)  id:修改时会有id参数
			showDialog(oper, row) {

				this.handleGoodsList();
				this.oper = oper;
				if (oper == 'edit') {
					this.id = row.id;
					this.userName = row.name;
					this.package_opt = row.package_opt;
					this.pay_mode = row.pay_mode;
					this.isAlert = true;
					this.handleEnp(row.id)

				} else if (oper == 'add') {
					this.id = '';
					this.pay_mode = '1';
					this.hasBackPackage = '1';
					this.userName = '';
					this.isAlert = true;
					this.appid = '';
					this.appsecret = '';
					this.ip = '';
				} else if (oper == 'editCompany') {
					this.isAlert = true;
					this.hasBackPackage = '1';
					// this.goodsCheckList = []
					this.handleEnp(this.enpId, (res) => {
						this.pay_mode = res.pay_mode
					})
				}
			},

			menuChange(key, data) {
				this.formData.power = data.checkedKeys.join(',');
			},

			formCancel() {
				//关闭弹窗 重置数据
				this.userName = '';
				this.isAlert = false;
				this.isAlert2 = false;
				this.isAlert3 = false;
			},

			formSubmit() {

				const that = this
				if (this.userName.trim() == '' || this.userName.trim() == undefined) {
					this.$myAlert({
						type: 'fail',
						title: '请输入企业名称'
					});
					return
				}
				/* if(this.formList && this.formList.length <= 0) {
					this.$myAlert({
						type: 'fail',
						title: '请最少选择一种套餐'
					});
					return
				} */

				let userData = {
					name: this.userName,
					pay_mode: this.pay_mode,
					status: this.corp_status,
					package: [],
				};
				let packageAll = []


				const arr = this.goodsList.map(g => g.id)
				packageAll = this.formList

				userData.package = packageAll
				userData.goods_ids = this.goodsCheckList.filter(g => that.goodsList.filter(gl => gl.id == g).length)
				userData.appid = this.appid
				userData.appsecret = this.appsecret
				userData.ip = this.ip
				if (this.oper == 'edit') {
					userData.act = 'update'
					userData.id = this.id

					delete userData.name
					delete userData.pay_mode
					delete userData.appid
					delete userData.appsecret
					delete userData.ip
					delete userData.status
					// 修改企业信息
					enterpriseList(userData).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleLoadCom();
							this.handleEnp(this.enpId);
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				} else if (this.oper == 'add') {
					// 新增企业
					if (this.hasBackPackage == '0') {
						delete userData.package
						delete userData.pay_mode
						delete userData.package_opt
					}
					userData.act = 'add'
					delete userData.package
					// return
					enterpriseList(userData).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleLoadCom();
							this.handleEnp(this.enpId);
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				} else if (this.oper == 'editCompany') {
					userData.act = 'update'
					userData.id = this.id
					delete userData.package
					// return 
					enterpriseList(userData).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleLoadCom();
							this.handleEnp(this.enpId);
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				}
			},
			formSubmit2() {
				if (this.userName.trim() == '' || this.userName.trim() == undefined) {
					this.$myAlert({
						type: 'fail',
						title: '请输入企业名称'
					});
					return
				}

				let userData = {
					name: this.userName,
					status: this.corp_status
				};
				userData.appid = this.appid
				userData.appsecret = this.appsecret
				userData.ip = this.ip

				if (this.oper == 'edit') {
					userData.act = 'update'
					userData.id = this.id
					// 修改企业信息
					enterpriseList(userData).then((res) => {
						if (res.code == 200) {
							this.formCancel();
							this.handleLoadCom();
							this.handleEnp(this.enpId);
							this.$myAlert({
								type: 'success',
								title: res.msg
							});
						} else {
							this.$myAlert({
								type: 'fail',
								title: res.msg
							});
						}
					})
				}

			},
			formSubmit3() {
				if (this.formList && this.formList.length <= 0) {
					this.$myAlert({
						type: 'fail',
						title: '请最少选择一种套餐'
					});
					return
				}

				let userData = {
					package_opt: this.package_opt,
					pay_mode: this.pay_mode,
					package: [],
				};
				let packageAll = []

				let customObj = {
					goods_id: '2',
					status: this.isCustom ? 1 : 0,
					custom: {}
				}


	
				packageAll = this.formList
				userData.package = packageAll
				userData.act = 'update'
				userData.id = this.id
				// 修改企业信息
				enterpriseList(userData).then((res) => {
					if (res.code == 200) {
						this.formCancel();
						this.handleLoadCom();
						this.handleEnp(this.enpId);
						this.$myAlert({
							type: 'success',
							title: res.msg
						});
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			remove() {
				this.$myAlert({
					title: '确定删除？',
					callback: () => { // 点击确认触发
					}
				});
			},
			handleIsEdit() {
				// this.isAlert2 = true;
				// this.oper = 'edit'
				this.handleEnp(this.enpId)
			},
			handleIsApiEdit() {
				this.isAlert3 = true;
				this.handleGoodsList()
				this.handleEnp(this.enpId)
				this.hasPackage = true;
			},
			handleEnp(id, callback) {
				if (!id) return
				this.enpId = id
				this.apiData = []
				this.isAPI = false
				this.appid = ''
				this.appsecret = ''
				this.ip = ''
				// this.hasApi = false
				this.hasPackage = false
				enterpriseList({
					act: 'query',
					id: id
				}).then((res) => {
					if (res.code == 200) {
						let result = JSON.parse(window.atob(res.data))
						if (callback) {
							callback(result)
						}
						this.id = id
						this.corpName = result.name
						this.corpId = id
						this.corp_status = result.status
						let list = []
						let checkList = []
						this.userName = result.name
						if (!result.goodsList || result.goodsList == '') {
							this.isAPI = true
						}
						this.appid = result.appid
						this.appsecret = result.appsecret
						this.ip = result.ip

						if (result.api && result.api != null) { // 是否含有套餐信息
							// this.hasApi = true
							this.appid = result.appid
							this.appsecret = result.appsecret
							this.ip = result.ip

						}
						if (result.goods_ids && result.goods_ids) {
							this.hasPackage = true
							this.goodsCheckList = result.goods_ids
						} else {

						}
						if (result.goodsList && result.goodsList.length > 0) {
							this.hasPackage = true
							this.userPackage = result.goodsList;
						} else {
							this.userPackage = []
						}

						if (result.goodsList && result.goodsList.length > 0 && 0) {
							this.hasPackage = true

							let goods_list = []
							result.goodsList.map((item, index) => {
								goods_list.push(item)
								if (result.pay_mode == '1') {
									list.push(item)
								}
								if (result.pay_mode == '2' && item.status == 1) {
									list.push(item)
								}
								if (item.goods_id == '2') {
									let deathList = []
									let dieList = []
									for (let j in death) {
										deathList.push([death[j], j]);
									}
									let hasUsed = false
									deathList.map((itemV, index) => {
										let arr = itemV[0]
										arr.key = itemV[1]
										if (itemV[0].used && itemV[0].used > 0) {
											hasUsed = true
										}
										if (result.pay_mode == '1') {
											dieList.push(arr)
											checkList.push(itemV[1])
										}
										if (result.pay_mode == '2' && itemV[0].status == 1) {
											dieList.push(arr)
											checkList.push(itemV[1])
										}
										this.hasUsed = hasUsed
									})
									item.children = dieList
								}
							})

							if (checkList.length > 0) {
								this.isCustom = true
							} else {
								this.isCustom = false
							}
							if (result.pay_mode == '2') {
								let newList = []
								for (let i = 0; i < goods_list.length; i++) {
									if (this.goodsCheckList.indexOf(goods_list[i].goods_id) <= -1) {
										newList.push(goods_list[i].goods_id)
									} else if (this.goodsCheckList.indexOf(goods_list[i].goods_id) > -1 &&
										goods_list[i].status == '0') {
										newList.push(goods_list[i].goods_id)
									}

								}
								let goods_id_list = []
								goods_list.map((item, index) => {
									if (newList.indexOf(item.goods_id) <= -1) {
										goods_id_list.push(item.goods_id)
									}
								})
								// this.goodsCheckList = goods_id_list
							}
							if (result.pay_mode == '1') {
								this.isCustom = true
								this.hasPackage = true

							}



						}
						this.userData = result;

					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			handleReport(id, pk, type) {
				if (type == 'M22') {
					window.open('/m22/lookReport.html?id=' + id);
				} else if (pk && pk == 3) { // 母婴
					window.open('/muying/report/classify.html?id=' + id);
				} else if (pk && pk == 5) { //AI健康
					window.open('/kyzc/lookReport.html?id=' + id);
				} else if (pk && pk == 6) { //AI骨折
					window.open('/fb/lookReport.html?id=' + id);
				} else {
					let openUrl = this.$router.resolve({
						path: "/reportPrint/lookReport",
						query: {
							id: id
						}
					});

					window.open(openUrl.href);
				}

			},
			changeAddTimes(val) {
				if (val <= 0) {
					this.$myAlert({
						type: 'fail',
						title: '增添次数最小为1'
					});
				}else if(val >= 10000){
					this.$myAlert({
						type: 'fail',
						title: '增添次数最大为10000'
					});
				}
			}

		}
	}
</script>

<style scoped>
	
	.right-temp >>> .el-input{
		width: 400px;
		flex: 0 0  auto;
	}
	
	
	.right-temp >>> .el-radio-group{
		
		display: flex;
		flex-wrap:wrap;
	}
	.right-temp >>> .el-checkbox{
		height: 44px;
		display: flex;
		align-items: center;
	}
	
	.right-temp >>> .el-radio{
		height: 44px;
		display: flex;
		align-items: center;
	}
	.right-temp >>> .el-switch{
		height: 44px;
		display: flex;
		align-items: center;
	}
	
	.checkbox-group-box >>> .el-checkbox__label{
		padding-left: 4px;
	}
	
	.el-dialog .el-form>>>.el-form-item__label {
		width: 16%;
		padding-right: 0;
		margin-left: 4%;
		text-align: left;
	}

	.el-dialog .el-form>>>.el-form-item__content {
		float: left;
		width: 60%;
		margin-right: 0;
	}

	.popup-wrap>>>input::-webkit-outer-spin-button,
	.popup-wrap>>>input::-webkit-inner-spin-button {
		-webkit-appearance: none;
	}

	.popup-wrap>>>input[type="number"] {
		-moz-appearance: textfield;
	}

	.product .el-checkbox,
	.product>>>.el-checkbox__input {
		position: absolute;
		top: 0;
		left: 0;
		font-weight: 400;
	}

	.product>>>.el-checkbox__inner {
		width: 18px;
		height: 16px;
		border-radius: 6px 0 6px 0;
	}

	.product>>>.el-checkbox__inner::after {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%)rotate(45deg)scaleY(0);
	}

	.product>>>.el-checkbox__input.is-checked .el-checkbox__inner::after {
		transform: translate(-50%, -50%)rotate(45deg)scaleY(1);
	}

	.product>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	.product>>>.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		border-color: #6681FA;
		background-color: #6681FA;
	}

	.product>>>.el-checkbox__label {
		display: none;
	}

	.item-check>>>input {
		border: none;
		border-bottom: 1px solid #DCDFE6;
	}

	.right-list>>>.el-table th,
	.el-table tr {
		background-color: #F2F4FA;
	}

	.right-list>>>.el-table th>.cell {
		color: #293033;
	}

	.popup-wrap>>>.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
		font-weight: 400;
	}

	.popup-wrap>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
		font-weight: 400;
	}

	/* .popup-wrap >>> .el-switch__core:after {
		background-color: #828DBC;
	}
	.popup-wrap >>> .el-switch.is-checked .el-switch__core::after {
		background-color: #6681FA;	
	} */
	.popup-wrap>>>.el-input-number__increase {
		display: none;
	}

	.popup-wrap>>>.el-input-number__decrease {
		display: none;
	}

	.popup-wrap .input-number>>>.el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}

	.add-times>>>.el-input-number__increase {
		display: none;
	}

	.add-times>>>.el-input-number__decrease {
		display: none;
	}

	.add-times .input-number>>>.el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}

	.add-times>>>.el-input-number .el-input__inner {
		padding: 0 16px;
		text-align: left;
		width: 400px;
	}

	.right-list>>>.el-table .cell {
		display: flex;
	}

	.right-list>>>.el-collapse {
		border: none;
	}

	.right-list>>>.el-collapse-item__header {
		border: none;
		background-color: transparent;
		font-size: 14px;
		font-weight: 400;
		color: #525866;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.right-list>>>.el-collapse-item__wrap {
		background-color: transparent;
	}

	.popup-wrap>>>.el-checkbox {
		font-weight: 400;
	}

	.margin-bottom-1>>>.el-input__inner {
		width: 420px;
	}

	.api-cell>>>.el-input-number {
		width: 100%;
	}

	.api-cell>>>.el-input-number .el-input__inner {
		text-align: left;
		padding: 0 10px;
	}

	.empty-wrap {
		padding: 100px 0;
	}

	.empty-img {
		width: 338px;
		height: 218px;
	}
	
	
	.el-table >>> .cell{
		white-space: nowrap;
		overflow: hidden;
	}


</style>
<style lang="scss" scoped>
	.role {
		display: flex;
		width: 100%;
		height: 100%;

		.el-icon-circle-plus-outline {
			font-size: 18px;
			color: #6883FB;
		}

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;
			overflow-y: auto;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}


			.left-enp-item {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				cursor: pointer;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;

				&:hover {
					color: #7a92fb;
				}
			}

			.left-enp-item-active {
				display: flex;
				align-items: center;
				width: 100%;
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				cursor: pointer;
			}

			.enp-item-status {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #FF5219;
				background-color: #FDE8E2;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}

			.enp-item-name {
				flex: 1;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.enp-item-status-active {
				width: 20px;
				height: 20px;
				font-size: 12px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #6883FB;
				background-color: #DCE3FF;
				margin-right: 4px;
				padding-top: 1px;
				border-radius: 50%;
				text-align: center;
			}
		}

		.right-list {
			flex: 1;
			padding: 30px 24px;
			overflow: auto;
		}

		.add {
			padding: 8px 12px;
			margin: 24px 0 12px;
		}

		.el-table {
			i[class^=el-icon] {
				margin-right: 8px;
				cursor: pointer;
			}
		}

		.el-pagination {
			text-align: center;
			margin-top: 32px;
		}

		.el-dialog {
			.all-power {
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
				width: 100%;
			}

			.dialog-footer {
				.el-button {
					padding: 9px 15px;
					font-size: 16px;
				}
			}
		}
	}

	.el-dialog {
		.dialog-title {
			font-size: 18px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			text-align: center;
		}

		.dialog-footer {
			display: flex;
			align-items: center;
			justify-content: center;

			.cancel-btn {
				width: 94px;
				height: 34px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				border: 1px solid #6883FB;
				border-radius: 17px;
				background-color: #fff;
			}

			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #fff;
				border: none;
				border-radius: 17px;
				background-color: #6883FB;
				margin-left: 16px;
			}

			.el-button {
				padding: 9px 15px;
			}
		}
	}

	.popup-wrap {
		padding: 0 20px;
	}

	.right-temp {
		height: fit-content;
		margin-bottom: 0px;

		.temp-title-cell {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding-bottom: 10px;
			border-bottom: 1px solid #E5E8F5;
		}

		.temp-title {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-size: 18px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #293033;
			line-height: 24px;
		}

		.temp-info {
			margin-right: 20px;
		}
	}

	// .submit-btn {
	// 	width: 94px;
	// 	height: 34px;
	// 	font-size: 15px;
	// 	font-family: PingFangSC-Medium, PingFang SC;
	// 	font-weight: 500;
	// 	color: #FFFFFF;
	// 	line-height: 34px;
	// 	background-color: #6883FB;
	// 	border-radius: 17px;
	// 	border: none;
	// 	margin-top: 10px;
	// }


	.input-number {
		width: 50px;
	}

	.custom-info {
		position: relative;
		width: 100%;
		padding: 24px;
		border: 1px solid #CED4F0;
		border-radius: 4px;
		margin-top: 10px;

		&::before {
			box-sizing: content-box;
			position: absolute;
			width: 0;
			height: 0;
			top: -16px;
			left: 41px;
			padding: 0;
			border-top: 8px solid transparent;
			border-left: 8px solid transparent;
			border-right: 8px solid transparent;
			border-bottom: 8px solid #fff;
			display: block;
			content: '';
			z-index: 12;
		}

		&::after {
			box-sizing: content-box;
			position: absolute;
			width: 0;
			height: 0;
			top: -18px;
			left: 40px;
			padding: 0;
			border-top: 9px solid transparent;
			border-left: 9px solid transparent;
			border-right: 9px solid transparent;
			border-bottom: 9px solid #CED4F0;
			display: block;
			content: '';
			z-index: 10;
		}
	}

	.custom-group {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		width: fit-content;

		.custom-item {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 30%;
			margin-right: 20px;
		}
	}

	.item-cell {
		display: flex;
		align-items: center;
		margin-bottom: 20px;

		// padding: 0 0.4px;
		.item-label {
			// width: 2px;
			margin-right: 20px;
		}

		.item-input {
			width: 300px;
			margin-right: 10px;
		}
	}

	.has-used {
		color: #6883fb;
	}

	.no-used {
		color: #eb928f;
	}

	.product {
		width: 193px;
		height: 56px;
		line-height: 18px;
		border-radius: 6px 0 6px 0;
		cursor: pointer;

		.name {
			top: 50%;
			left: 50%;
			width: 100%;
			transform: translate(-50%, -50%);
			text-align: center;
		}

		&.basic {
			color: #40444D;
			background-color: #F0F4F7;
		}

		&.PLM {
			color: #C07E37;
			background-color: #FCF9F0;
		}

		&.comorbidity {
			color: #C92B5C;
			background-color: #FCF5F2;
		}

		&.illness {
			color: #5843BE;
			background-color: #F6F5FC;
		}

		&.health {
			color: #1955AF;
			background-color: #F0F6FC;
		}
	}

	.item-check .base-count {
		display: flex;
		align-items: center;
		width: 193px;
		margin-bottom: 16px;

		.item-check-input {
			width: 80px;
			margin-right: 10px;
		}
	}

	.count {
		font-size: 13px;
		line-height: 13px;
		color: #777F8F;
		margin-top: 6px;
	}

	.el-checkbox-group {
		display: flex;
		flex-wrap: wrap;


		div.qjc-fl {
			margin-right: 16px;
		}

		.c-danger {
			color: #FF4C52;
		}
	}

	.item-check {
		margin-bottom: 30px;
	}

	.radio-box {
		margin-left: 30px;
	}

	.edit-action {

		// cursor: pointer;
		.el-icon-edit {
			color: #6883FB;
		}

		.edit-text {
			font-size: 14px;
			// font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 400;
			color: #6883FB;
			line-height: 18px;
			margin-right: 10px;
			cursor: pointer;

			&:hover {
				color: #7A92FB;
			}
		}
	}

	.add-times {
		.add-times-label {
			width: 100px;
			font-size: 14px;
			font-family: PingFangSC-Regular, PingFang SC;
			font-weight: 400;
			color: #293033;
			text-align: right;
			margin-right: 10px;
		}

		.foot-btn {
			margin-top: 32px;
			text-align: center;
		}

		.cancel-btn {
			width: 94px;
			height: 34px;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			border: 1px solid #6883FB;
			border-radius: 17px;
			background-color: #fff;
		}

		.submit-btn {
			width: 94px;
			height: 34px;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
			border: none;
			border-radius: 17px;
			background-color: #6883FB;
			margin-left: 16px;
		}

		.el-button {
			padding: 9px 15px;
		}
	}

	.tips-name {
		height: 48px;
		line-height: 48px;
	}

	.tips-text {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #B4BBCC;
	}

	.right-btn {
		width: 86px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #525866;
		border-radius: 4px;
		border: 1px solid #DBDDE6;
		background-color: #fff;
		margin-bottom: 14px;
	}

	.right-btn-active {
		width: 86px;
		height: 34px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FFFFFF;
		border-radius: 4px;
		border: none;
		background-color: #6883FB;
		// margin-bottom: 14px;
	}

	.margin-bottom-1 {
		margin-bottom: 10px;
	}

	.width-80 {
		width: 120px !important;
	}

	.api-cell {
		display: flex;
		align-items: flex-start;
		margin-bottom: 10px;
		height: fit-content;

		.api-cell-title {
			width: 200px;
			text-align: right;
			line-height: 44px;
			margin-right: 10px;
		}
	}

	.corp_name {
		font-size: 28px;
		// margin-bottom: 24px;
		margin-right: 30px;
	}

	.right-query {
		display: flex;
		align-items: center;
		margin-bottom: 24px;
	}

	.padding_left_20 {
		padding-left: 20px
	}

	.used_cell {
		display: flex;
		align-items: center;
	}

	.used_cell_btn {
		font-size: 14px;
		font-weight: 400;
		color: #6883FB;
		line-height: 18px;
		margin-left: 10px;
		cursor: pointer;
	}
	
	.checkbox-group-box{
		display:flex;
		flex-wrap: wrap;
		
	}
	
</style>